export default __webpack_public_path__ + "static/media/biografi.f5abecd5.png";